<template>
  <b-container class="wrap-category-detail">
    <b-row class="box-head">
      <b-col cols="12" md="8" class="box-breadcrumb">
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>
      <b-col cols="12" md="4" class="box-back-btn">
        <button @click.prevent="goBack()">
          Back to Award
        </button>
      </b-col>
    </b-row>
    <div class="wrap-content">
      <h1>{{ title }}</h1>
      <!-- <div
        v-if="subCate"
        class="box-content"
      >

        <h2>{{ subCate.name }}</h2>
        {{subCate}}
        <div
          v-for="content in subCate.award"
          :key="content.id"
          class="box-context"
        >
        {{content}}
          <div class="box"></div>
          <div class="box-text">
            <h3>{{ content.name }}</h3>
            <hr>
            <span v-html="content.content"></span>
          </div>
        </div>
      </div> -->

      <!-- TODO: swap subContents, content to  content, subContents -->
      <div v-if="contents" class="box-content">
        <div v-for="(content, contentIndex) in contents" :key="content.id">
          <template v-if="content.id === 295 && contentIndex === 0">
            <div class="" style="padding-top: 30px;"></div>
            <div class="box-text-2">
              <h3 v-html="highlightNew(content.name_award)"></h3>
              <p v-html="highlightNew(content.content)"></p>
            </div>
          </template>
          <template v-else-if="content.id === 301 && contentIndex === 0">
            <div class="" style="padding-top: 30px;"></div>
            <div class="box-text-2" style="padding-bottom: 22px;">
              <h3 v-html="highlightNew(content.name_award)"></h3>
              <p v-html="highlightNew(content.content)"></p>
            </div>
          </template>
          <template v-else-if="!content.name_award && contentIndex === 0">
            <div class=""></div>
            <div class="box-text-2">
              <h3 v-html="highlightNew(content.name_award)"></h3>
              <p v-html="highlightNew(content.content)"></p>
            </div>
          </template>
          <template v-else>
            <div class="box"></div>
            <div class="box-text">
              <h3 v-html="highlightNew(content.name_award)"></h3>
              <p v-html="highlightNew(content.content)"></p>
            </div>
          </template>
        </div>
      </div>

      <div v-if="subContents" class="box-content">
        <div v-for="content in subContents" :key="content.id" class="box-detail">
          <h2 v-if="content.name_awards_sub">{{ content.name_awards_sub }}</h2>
          <div v-for="(award, index) in content.award" :key="award.id">
            <template v-if="!award.name_award && index === 0">
              <div class=""></div>
              <div class="box-text-2">
                <h3 v-html="highlightNew(award.name_award)"></h3>
                <p v-html="highlightNew(award.content)"></p>
              </div>
            </template>
            <template v-else>
              <div class="box"></div>
              <div class="box-text">
                <h3 v-html="highlightNew(award.name_award)"></h3>
                <p v-html="highlightNew(award.content)"></p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Award',
          to: {
            name: 'awards'
          }
        }
      ],
      title: '',
      contents: [],
      subContents: []
    }
  },

  computed: {
    ...mapState({
      categoriesList: state => state.awards.categoriesList,
      categoriesDetail: state => state.awards.categoriesDetail
    }),

    routeParam () {
      return this.$route.params.id
    }
  },

  methods: {
    highlightNew (value) {
      if (typeof value !== 'string') return value

      return value.replace(/\*\*\*NEW/g, '<span class="new-text">***NEW</span>')
    },

    checkTitle (data) {
      if (data) {
        data.forEach((item, i) => {
          if (i === 0) {
            this.title = item.name

            const obj = {
              text: item.name
            }

            this.breadcrumbs.push(obj)
          }
        })
      }
    },

    macthContents (data) {
      if (data) {
        this.contents = []
        this.subContents = []
        data.forEach(item => {
          // TODO: comment old code
          // if (item.subcategory) {
          //   item.subcategory.forEach(sub => {
          //     this.subContents.push(sub)
          //     // sub.award.forEach(award => {
          //     // this.contents.push(award)
          //     // })
          //     // this.contents.push(sub.award)
          //     // this.contents = sub.award
          //     this.subCate = sub.name
          //   })
          // } else {
          //   item.award.forEach(award => {
          //     this.contents.push(award)
          //   })
          //   // this.contents.push(item.award)
          //   // this.contents = item.award
          // }

          // TODO: hard code move last element to first element
          // if (item.name === 'DESIGN' && item.id === 3) {
          //   const lastElement = item.award.pop()
          //   item.award.unshift(lastElement)
          // }

          if (item.subcategory && item.subcategory.length > 0) {
            item.subcategory = item.subcategory.sort((a, b) => a.ordering - b.ordering)
            item.subcategory.forEach(sub => {
              // TODO: hard code sort name_award to ASC
              if (sub.name_awards_sub === 'B. CHANNELS') {
                sub.award = sub.award.sort((a, b) => {
                  const codeA = parseInt(a.name_award.slice(1, 3))
                  const codeB = parseInt(b.name_award.slice(1, 3))
                  return codeA - codeB
                })
              } else {
                sub.award = sub.award.sort((a, b) => a.name_award.localeCompare(b.name_award))
              }
              // console.log(sub.id)
              this.subContents.push(sub)
              this.subCate = sub.name
            })
          }
          if (item.award && item.award.length > 0) {
            item.award = item.award.sort((a, b) => a.name_award.localeCompare(b.name_award))
            item.award.forEach(award => {
              this.contents.push(award)
            })
          }
        })
      }
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  created () {
    if (!this.categoriesDetail) {
      this.$store.dispatch('awards/getCateDetail', this.$route.params.id)
    }

    this.checkTitle()
    this.macthContents(this.categoriesDetail)
  },

  watch: {
    categoriesDetail (data) {
      this.checkTitle(data)
      this.macthContents(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-category-detail {
  .box-head {
    padding: 22px 0;
    border-bottom: 1px solid #CCC;

    .box-breadcrumb {
      display: flex;
      align-items: center;

      .breadcrumb {
        margin: 0;
        padding: 0;
        background: none;

        li {
          font-size: 1.25rem;
          font-family: var(--button-default-font-family, "DB Adman X");

          a {
            color: black;
          }
        }
      }
    }

    .box-back-btn {
      margin-top: 22px;

      @media only screen and (min-width: $break-m) {
        margin-top: 0;
      }

      button {
        width: 100%;
        background-color: #CCC;
        padding: 12px 0;
        font-size: 1.25rem;
        font-family: var(--button-default-font-family, "DB Adman X");
      }
    }
  }

  .wrap-content {
    padding: 22px 0 0 0;

    h1 {
      margin: 12px 0 11px 0;
      font-size: 2.5rem;
      color: #6D6E71;
      font-family: var(--h3-font-family, "DB HelvethaicaMon X");
    }

    .box-content {
      margin-bottom: 22px;

      .box-detail {
        padding-bottom: 12px;
      }

      .box {
        float: left;
        margin: 8px 0 0 0;
        width: 15px;
        height: 15px;
        background-color: $active;
      }

      h2 {
        padding: 11px 0;
        font-size: 2.75rem;
        color: #c82127;
        font-family: var(--h3-font-family, "DB HelvethaicaMon X");
      }

      .box-text {
        margin-left: 22px;

        h3 {
          padding: 0 0;
          font-size: 1.75rem;
          border-bottom: 1px solid #CCC;
          font-family: var(--h3-font-family, "DB HelvethaicaMon X");
        }

        p {
          padding: 11px 0 16px 0;
          font-size: 1rem;
          line-height: 1.5;
          font-family: var(--body-upscale-font-family, Sarabun);
        }
      }

      .box-text-2 {
        margin-top: -10px;

        h3 {
          padding: 0 0;
          font-size: 1.75rem;
          font-family: var(--h3-font-family, "DB HelvethaicaMon X");
        }

        p {
          padding: 11px 0 16px 0;
          font-size: 1rem;
          line-height: 1.5;
          font-family: var(--body-upscale-font-family, Sarabun);
        }
      }

      ::v-deep .new-text {
        color: #da0401;
      }

      .box-1 {
        float: left;
        margin: 8px 0 0 0;
        width: 15px;
        height: 15px;
      }

      .box-text-3 {
        margin-left: 22px;

        h3 {
          padding: 0 0;
          font-size: 1.75rem;
          border-bottom: 1px solid #CCC;
          font-family: var(--h3-font-family, "DB HelvethaicaMon X");
        }

        p {
          padding: 11px 0 16px 0;
          font-size: 1rem;
          line-height: 1.5;
          font-family: var(--body-upscale-font-family, Sarabun);
        }
      }

      // h2 {
      //   margin-bottom: 12px;
      //   font-size: 2.75rem;
      //   color: $active;
      // }

      // .box-context {
      //   margin-bottom: 22px;

      //   .box {
      //     display: inline-block;
      //     // margin-top: 8px;
      //     width: 15px;
      //     height: 15px;
      //     background-color: $active;
      //   }

      //   .box-text {
      //     display: inline-block;
      //     margin-top: -32px;
      //     margin-left: 22px;

      //     h3 {
      //       font-size: 1.75rem;
      //     }

      //     p {
      //       line-height: 0.8;
      //       font-size: 1.25rem;
      //     }
      //   }
      // }
    }
  }
}
</style>
